export const validateLatitude = (_, value) => {
  if (value === undefined || value === null || value === '') return Promise.resolve();
  const num = parseFloat(value);
  if (isNaN(num) || num < -90 || num > 90) {
    return Promise.reject(new Error('Latitude must be between -90 and 90'));
  }
  return Promise.resolve();
};

export const validateLongitude = (_, value) => {
  if (value === undefined || value === null || value === '') return Promise.resolve();
  const num = parseFloat(value);
  if (isNaN(num) || num < -180 || num > 180) {
    return Promise.reject(new Error('Longitude must be between -180 and 180'));
  }
  return Promise.resolve();
};

export const validatePositiveDecimal = (_, value) => {
  if (value === undefined || value === null || value === '') return Promise.resolve();
  const num = parseFloat(value);
  if (isNaN(num) || num < 0) {
    return Promise.reject(new Error('Value must be a positive number'));
  }
  return Promise.resolve();
};

export const validatePositiveDecimalGreaterThanZero = (_, value) => {
  if (value === undefined || value === null || value === '') {
    return Promise.resolve();
  }
  const num = parseFloat(value);
  if (isNaN(num) || num <= 0) {
    return Promise.reject(new Error('Value must be greater than 0'));
  }
  return Promise.resolve();
};


export const validateMinOrMaxFactory = form => (_, value) => {
  const min = form.getFieldValue('minValue');
  const max = form.getFieldValue('maxValue');
  if (min == null && max == null) {
    return Promise.reject(new Error('Min or Max must be filled'));
  }
  return Promise.resolve();
};

export const validateMinLessThanMaxFactory = (form) => (_, value) => {
  const min = form.getFieldValue("minValue");
  const max = value;
  if (min == null && max == null) {
    return Promise.reject(new Error("Min or Max must be filled"));
  }
  if (min != null && max != null && min >= max) {
    return Promise.reject(new Error("Min must be less than Max"));
  }
  return Promise.resolve();
};


export const validateSerialNumber = (_, value) => {
  if (value === undefined || value === null || value === '') return Promise.resolve();

  // Solo dígitos, permitiendo ceros iniciales
  const regex = /^[0-9]+$/;
  if (!regex.test(value)) {
    return Promise.reject(new Error('Serial number must contain only digits (0-9)'));
  }

  return Promise.resolve();
};

export const validateElementsAndPeriodicities = (form) => (_, value) => {
  const selected = form.getFieldValue("selectedElements") || [];

  if (!selected.length) {
    return Promise.reject(new Error("Please select at least one element"));
  }

  const invalid = selected.some((id) => {
    const periodicities = form.getFieldValue(["elementPeriodicities", id]);
    return !periodicities || periodicities.length === 0;
  });

  if (invalid) {
    return Promise.reject(
      new Error("Each selected element must have at least one periodicity")
    );
  }

  return Promise.resolve();
};

